module.exports = __webpack_public_path__ + "img/photo-0036.6e1e81fa.jpg";